import axios from "@/axios-instance";
import moment from "moment";

// In "Phiếu xác nhận ưu đãi/học bổng" qua SIS report — TÁCH từ admissionProcedureListDetail.printInfo
// để dùng chung với tab Hồ sơ nhập học ở chi tiết ứng viên (tránh 2 bản trôi nhau).
// applicant = bản ghi phiếu nhập học (cần admissionRegistration/programtype/studentCode/định danh);
// dataPrint = entry freeTuitionRegistration (học bổng, có .scholarships) HOẶC orderDetails.promotion (ưu đãi).

const num2Word2 = function () {
    var t = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"],
        r = function (r, n) {
            var o = "",
                a = Math.floor(r / 10),
                e = r % 10;
            return a > 1 ? (o = " " + t[a] + " mươi", 1 == e && (o += " mốt")) : 1 == a ? (o = " mười", 1 == e && (o += " một")) : n && e > 0 && (o = " lẻ"), 5 == e && a >= 1 ? o += " lăm" : 4 == e && a >= 1 ? o += " bốn" : (e > 1 || 1 == e && 0 == a) && (o += " " + t[e]), o
        },
        n = function (n, o) {
            var a = "",
                e = Math.floor(n / 100),
                n = n % 100 as any;
            return o || e > 0 ? (a = " " + t[e] + " trăm", a += r(n, !0)) : a = r(n, !1), a
        },
        o = function (t, r) {
            var o = "",
                a = Math.floor(t / 1e6),
                t = t % 1e6 as any;
            a > 0 && (o = n(a, r) + " triệu", r = !0);
            var e = Math.floor(t / 1e3),
                t = t % 1e3 as any;
            return e > 0 && (o += n(e, r) + " ngàn", r = !0), t > 0 && (o += n(t, r)), o
        };
    return {
        convert: function (r) {
            if (0 == r) return t[0];
            var n = "",
                a = "";
            do var ty = r % 1e9 as any,
                r = Math.floor(r / 1e9) as any,
                n = r > 0 ? o(ty, !0) + a + n : o(ty, !1) + a + n,
                a = " tỷ"; while (r > 0);
            return n.trim()
        }
    }
}();

export async function printUuDaiHocBong(applicant: any, dataPrint: any) {
    // Học phí toàn khóa theo ngành + loại chương trình (chỉ ĐỌC setting — không đụng logic tính tiền)
    let dataTuition: any = {}
    await axios.get(`/setting/tuition?majorcode=${applicant?.admissionRegistration?.adMajorCode}&programtype=${applicant?.programtype}`)
        .then(({ data }) => {
            if (data && data.length != 0) dataTuition = data[0]
        })
        .catch(({ response }) => {
            console.log('err', response)
        });

    let textMoney = num2Word2.convert(dataTuition.wholeCourseFee)
    textMoney = textMoney.charAt(0).toUpperCase() + textMoney.slice(1);
    // DB lưu type chữ thường ('svsl'...) — normalize trước khi tra map kẻo rớt key
    // typeName -> JSON.stringify bỏ luôn field -> SIS load undefined.mrt (phiếu trắng)
    let typeName = String(dataPrint.scholarships?.type || dataPrint.promotionCode || '').toLowerCase()
    let objName = {
        svsl: 'HocBongSVSL',
        active: 'HocBongActive',
        future: 'HocBongFuture',
        global: 'HocBongGlobal',
        liberal: 'HocBongLiberal',
        unique: 'HocBongUnique',
        doanhnghiep: 'HocBongDoanhNghiep',
    }
    let tilegiam = (dataPrint.scholarships?.discount * 100) || dataPrint.value
    tilegiam = (+tilegiam).toFixed(0)
    if (typeName == 'global') {
        tilegiam = 100 as any
    }
    let tenhocbong = dataPrint.scholarships?.name || dataPrint.name
    let hoten = applicant.familyName + ' ' + applicant.middleName + ' ' + applicant.givenName
    let tempData = {
        "hoten": hoten,
        "MSSV": applicant.studentCode,
        "ngaysinh": applicant.dateOfBirth ? moment(applicant.dateOfBirth).format('DD/MM/YYYY') : '',
        "CCCD": applicant.idNumber,
        "CCCD_ngaycap": applicant.issuedDate ? moment(applicant.issuedDate).format('DD/MM/YYYY') : '',
        "CCCD_noicap": applicant.issuedBy,
        "nganhhoc": applicant.admissionRegistration?.adMajorName,
        "nganhhoc_en": applicant.admissionRegistration?.adMajorName,
        // Liên thông (idAdMethod=9) đào tạo 2 năm -> niên khóa 2 năm; hệ khác 4 năm
        "nienkhoa": `${new Date().getFullYear()}-${new Date().getFullYear() + (applicant.admissionRegistration?.idAdMethod == 9 ? 2 : 4)}`,
        "hocphitoankhoa": dataTuition.wholeCourseFee,
        "hocphitoankhoa_word": textMoney,
        "tenhocbong": tenhocbong,
        "tilegiam": ` Giảm ${tilegiam}% toàn khóa`,
        "fileName": `${objName[typeName]} - ${hoten}`,
        "typeName": objName[typeName],
    }
    const href = `https://sisadmin.umt.edu.vn/reports/scholarship/report/?dataPrint=${JSON.stringify(tempData)}`
    const link = document.createElement('a')
    link.setAttribute('target', '_blank')
    link.href = `${href}`
    document.body.appendChild(link)
    link.click()
}
